/* eslint-disable import/prefer-default-export */

export const ENTER_ADDRESS = 0;
export const CONFIRM_ADDRESS = 1;
export const COVERED_BY_THD = 2;
export const COVERED_BY_OTHER = 3;
export const INELIGIBLE_FOR_THD = 4;
